module.exports = __webpack_public_path__ + "static/media/Stonk-Stock-Page.949dd6c5.png";